import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'classifyValidationError'
})
export class ClassifyValidationErrorPipe implements PipeTransform {
  transform(value: { [errorType: string]: boolean } | null | undefined): string {
    if (value) {
      const errorTypes: string[] = Object.keys(value);
      for (const errorType of errorTypes) {
        if (value[errorType]) {
          return errorType;
        }
      }
    }

    return '';
  }
}
